export const workplaceWork = {
    "workNormal":"Work Normal",
    "assignWorkNormal":"Assigned by me",
    "createdWorkNormal":"Performed by me",
    "followerWorkNormal":"Follower by me",
    "departWorkNormal":"My department",
}